import React from 'react';

import PropTypes from 'prop-types';
import TilesChoose from 'components/map/TilesChoose';
import RulerHelper from './RulerHelper';
import UavosFilters from './UavosFilters';
import ZonesFilters from './ZonesFilter';
import ZonesCategoriesFilters from './ZonesCategoriesFilter';

import { FiltersDetailsUseStyles } from './FiltersDetailsUseStyles';

const FiltersDetails = props => {
  const {
    details,
    setZonesFilters,
    setZonesCategoriesFilters,
    zonesCategoriesFilters,
  } = props;

  const classes = FiltersDetailsUseStyles();

  const handleSource = () => <UavosFilters />;

  const handleZones = () => <ZonesFilters setZonesFilters={setZonesFilters} />;

  const handlePublic = () => (
    <ZonesCategoriesFilters
      setZonesCategoriesFilters={setZonesCategoriesFilters}
      zonesCategoriesFilters={zonesCategoriesFilters}
    />
  );

  const handleRuler = () => <RulerHelper />;

  const handleMap = () => <TilesChoose />;

  const handleSelectDetails = () => {
    switch (details) {
      case 'source':
        return handleSource();
      case 'zones':
        return handleZones();
      case 'public':
        return handlePublic();
      case 'ruler':
        return handleRuler();
      case 'map':
        return handleMap();
      default:
        return handleZones();
    }
  };

  return (
    <div className={`${classes.FiltersDetails}__table`}>
      {handleSelectDetails()}
    </div>
  );
};

FiltersDetails.propTypes = {
  details: PropTypes.string,
  setZonesFilters: PropTypes.func,
  setZonesCategoriesFilters: PropTypes.func,
  zonesCategoriesFilters: PropTypes.array,
};

export default FiltersDetails;
